document.addEventListener('DOMContentLoaded', function () {

  // Accordion
  document.querySelectorAll('.guarden-card-accordion').forEach((root) => {
    const items = root.querySelectorAll('.gca-item');

    items.forEach((item) => {
      const btn = item.querySelector('.gca-trigger');
      const content = item.querySelector('.gca-content');

      if (!btn || !content) return;

      content.style.maxHeight = '0px';

      btn.addEventListener('click', () => {
        const active = item.classList.toggle('active');
        btn.setAttribute('aria-expanded', active ? 'true' : 'false');
        content.style.maxHeight = active ? content.scrollHeight + 'px' : '0px';
      });
    });
  });
});